import React, { memo } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { MenuSection, MenuSectionHeading, MenuList } from '@atlaskit/navigation-system';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import LinkMenuItem from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/link-menu-item-with-analytics/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import type { Features } from '../../common/types.tsx';
import { COMMON_ANALYTICS_ATTRIBUTES } from './constants.tsx';
import messages from './messages.tsx';

type Props = {
	features: Features;
};

const OperationsSection = ({ features }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const currentRoute = useCurrentRoute();

	return (
		<MenuSection isMenuListItem={fg('platform_design_system_nav4_sidenav_a11y')}>
			<MenuSectionHeading>{formatMessage(messages.heading)}</MenuSectionHeading>
			<MenuList>
				{features?.hasShiftFromOpsgenieToJira && (
					<LinkMenuItem
						analytics={{ ...COMMON_ANALYTICS_ATTRIBUTES, itemId: 'moveFromOpsgenieToJira' }}
						isSelected={currentRoute.name === 'eoc-unlock-operations'}
						href="/jira/settings/products/ops/unlock"
						elemAfter={<Lozenge appearance="new">{formatMessage(messages.newLozenge)}</Lozenge>}
					>
						{formatMessage(messages.shiftFromOpsgenieToJiraItem)}
					</LinkMenuItem>
				)}
				{features?.hasChatOpsToolAccess && (
					<LinkMenuItem
						analytics={{ ...COMMON_ANALYTICS_ATTRIBUTES, itemId: 'jsm-chatops-tools' }}
						href="/jira/settings/products/ops/jira-service-management-chatops-and-video-tools"
						isSelected={currentRoute.name === 'products-jsm-chatops-and-videos-tools'}
					>
						{formatMessage(messages.chatopsToolsItem)}
					</LinkMenuItem>
				)}
			</MenuList>
		</MenuSection>
	);
};

export default memo(OperationsSection);
